import { getState } from "../../../../state/store";
import { selectAppTypes } from "../../../../state/selectors";

import { appApplicationGroups, accessTypeRoles, accessTypeOptions } from "../../../../consts";
import { appsUtil, dateUtil } from "../../../../utils";

const formatRoles = (roles = []) => {
  return roles.map((role) => {
    const name = appApplicationGroups.find((item) => item.group === role)?.value;

    return { name, role };
  });
};

export const formatDate = (date) => {
  if (date instanceof Date) {
    const day = dateUtil.addLeadingZero(date.getDate());
    const month = dateUtil.addLeadingZero(date.getMonth() + 1);
    const year = date?.getFullYear();

    return `${day}.${month}.${year}`;
  }
};

const getAccessTypeForRole = (role) => {
  return Object.keys(accessTypeRoles).find((accessType) =>
    accessTypeRoles[accessType].includes(role)
  );
};

const getUserData = (IAPRolesConfig) => {
  const data = {
    roles: IAPRolesConfig?.roles.map((role) => role.id) ?? [],
    appTypes: IAPRolesConfig?.applications.map((app) => app.id) ?? [],
    markets: IAPRolesConfig?.markets.map((market) => market.id) ?? [],
    activeFrom: dateUtil.toTimestampNoTimezone(IAPRolesConfig?.activeFrom),
    activeTo: dateUtil.toTimestampNoTimezone(IAPRolesConfig?.activeTo)
  };

  return data;
};

const transformUserData = (usersData) => {
  const userApps = selectAppTypes()(getState()) ?? [];
  const roleOptions = appApplicationGroups.map((item) => {
    return { id: item.group, value: item.value };
  });

  const roles = usersData?.roles ?? [];
  const appTypes = (usersData?.appTypes ?? []).filter((appType) => userApps.includes(appType));
  const markets = usersData?.markets ?? [];

  const accessType = getAccessTypeForRole(roles[0]);

  const rolesConfig = {
    accessType: accessTypeOptions.find((opt) => opt.id === accessType),
    roles: roleOptions.filter((role) => roles.includes(role.id)),
    applications: appTypes.map((appType) => {
      return { id: appType, value: appsUtil.getAppName(appType) };
    }),
    markets: markets.map((m) => {
      return { id: m, value: m };
    }),
    activeFrom: usersData?.activeFrom,
    activeTo: usersData?.activeTo
  };

  return rolesConfig;
};

const validateConfig = (config) => {
  const invalidFields = {
    roles: !config?.roles?.length,
    from: !config?.activeFrom,
    to: !config?.activeTo,
    applications: false,
    markets: false
  };

  let isValid = config?.roles?.length && config?.activeFrom && config?.activeTo;

  if (!config?.isApplicationsDisabled) {
    isValid = isValid && config?.applications?.length;
    invalidFields.applications = !config?.applications?.length;
  }

  if (!config?.isMarketsDisabled) {
    isValid = isValid && config?.markets?.length;
    invalidFields.markets = !config?.markets?.length;
  }

  return { isValid, invalidFields };
};

export const adminRolesConfigUtils = {
  formatRoles,
  formatDate,
  getUserData,
  transformUserData,
  validateConfig
};
